<ng-container *ngIf="formControl; then formInput; else simpleInput"></ng-container>

<ng-template #formInput>
  <mat-form-field>
    <mat-label class="label">{{label}}</mat-label>
    <mat-hint *ngIf="hintMessage">{{hintMessage}}</mat-hint>
    <input #nativeElem
           matInput
           [name]="id"
           [type]="type"
           [placeholder]="placeholder"
           [maxlength]="maxlength"
           [formControl]="formControl"
           (input)="onChange($event)"
           (blur)="onBlur($event)"
           (keypress)="onKeypress($event)"
           [readonly]="isReadonly"
           [autocomplete]="'off'"
           [required]="required ? '' : null"/>
    <div class="step-arrow-wrapper" *ngIf="type === 'number'">
      <div (mousedown)="$event.preventDefault()" (click)="stepUp()" class="step-up-arrow"></div>
      <div (mousedown)="$event.preventDefault()" (click)="stepDown()" class="step-down-arrow"></div>
    </div>
    <mat-icon *ngIf="reactive" class="editIcon">edit</mat-icon>
    <mat-icon *ngIf="isSearch" matSuffix class="search-icon" (click)="onSearchPress()">search</mat-icon>
    <mat-icon *ngIf="showVisibilityToggle && type === 'password'"
              matSuffix class="visibility-icon" (click)="onTogglePasswordVisibility()">
      {{passwordVisible ? 'visibility_off' : 'visibility'}}
    </mat-icon>
    <mat-icon *ngIf="prefixIcon" matPrefix>{{prefixIcon}}</mat-icon>
  </mat-form-field>
  <app-form-error-list *ngIf="showValidations"
                       [errorMap]="formControl.errors">
  </app-form-error-list>
</ng-template>

<ng-template #simpleInput>
  <mat-form-field>
    <mat-label class="label">{{label}}</mat-label>
    <input #nativeElem
           matInput
           [name]="id"
           [type]="type"
           [value]="value"
           [placeholder]="placeholder"
           [maxlength]="maxlength"
           (input)="onChange($event)"
           (blur)="onBlur($event)"
           (keypress)="onKeypress($event)"
           [readonly]="isReadonly"
           [autocomplete]="'off'"
           [disabled]="isDisabled"
           [required]="required ? '' : null"/>
    <div class="step-arrow-wrapper" *ngIf="type === 'number'">
      <div (mousedown)="$event.preventDefault()" (click)="stepUp()" class="step-up-arrow"></div>
      <div (mousedown)="$event.preventDefault()" (click)="stepDown()" class="step-down-arrow"></div>
    </div>
    <mat-icon *ngIf="reactive" class="editIcon">edit</mat-icon>
    <mat-icon *ngIf="isSearch" matSuffix class="search-icon" (click)="onSearchPress()">search</mat-icon>
    <mat-icon *ngIf="showVisibilityToggle && type === 'password'"
              matSuffix class="visibility-icon" (click)="onTogglePasswordVisibility()">
      {{passwordVisible ? 'visibility_off' : 'visibility'}}
    </mat-icon>
  </mat-form-field>
</ng-template>
